"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoVideoComponent = exports.SpotPlayVideoComponent = void 0;
const app_1 = require("app");
const PreviewBox_1 = require("../PreviewBox/PreviewBox");
class SpotPlayVideoComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = [
            '.spot-two_plus_one',
            '.spot-product',
            '.spot-group-cascade',
            '.spot-multilink',
            '.spot-singlelink',
            '.spot-cascade',
            '.expand-collapse-item',
        ].join(', ');
    }
    OnInit() {
        this.el.forEach(el => {
            const playVideoButton = el.querySelector('.play-video-button');
            const playVideoWrapper = el.querySelector('.play-video-wrapper');
            if (playVideoButton && playVideoWrapper) {
                playVideoButton.addEventListener('click', function (event) {
                    (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, playVideoButton);
                    event.stopPropagation();
                });
                playVideoButton.addEventListener('keypress', function (event) {
                    if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                        (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, playVideoButton);
                    }
                });
                playVideoWrapper.addEventListener('click', function (event) {
                    (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, playVideoButton);
                });
            }
        });
    }
}
exports.SpotPlayVideoComponent = SpotPlayVideoComponent;
exports.promoVideoComponent = new SpotPlayVideoComponent();
